import bill1000 from "../../../images/cash/100_dollar.png"; // Reusing for 1000
import { DENOMINATIONS } from "../Cash/constant";

export const initialDenominations = [
  {
    ...DENOMINATIONS.find((d) => d.id === "bill100"),
    id: "bill1000",
    label: "1000 Dollars",
    value: 1000,
    inventory: 2,
    qty: "",
    image: bill1000,
  },
  ...DENOMINATIONS.map((d) => ({ ...d, inventory: "-", qty: "" })),
];

export const cashVaultMockData = [
  {
    id: "46",
    dateTime: "11/03/2026 10:32:48",
    date: "2026-03-11", // For sorting/filtering
    type: "Withdraw Cash",
    typeValue: "withdraw",
    amount: "100",
    createdBy: "QC cash vault manager",
    branch: "Nguyen's store",
    reason: "sss",
    totalCash: "2,000",
    totalToPay: "100",
    denominations: [
      {
        ...DENOMINATIONS.find((d) => d.id === "bill100"),
        id: "bill1000",
        label: "1000 Dollars",
        value: 1000,
        inventory: 2,
        qty: 0,
        image: bill1000,
      },
      ...DENOMINATIONS.map((d) => ({
        ...d,
        inventory: "-",
        qty: d.id === "bill100" ? 1 : 0,
      })),
    ],
  },
  {
    id: "45",
    dateTime: "02/03/2026 09:45:01",
    date: "2026-03-02",
    type: "Deposit Cash",
    typeValue: "deposit",
    amount: "1,100",
    createdBy: "QC cash vault manager",
    branch: "Nguyen's store",
    reason: "Daily deposit",
    totalCash: "2,000",
    totalToPay: "1,100",
    denominations: [
      {
        ...DENOMINATIONS.find((d) => d.id === "bill100"),
        id: "bill1000",
        label: "1000 Dollars",
        value: 1000,
        inventory: 2,
        qty: 1,
        image: bill1000,
      },
      ...DENOMINATIONS.map((d) => ({
        ...d,
        inventory: "-",
        qty: d.id === "bill100" ? 1 : 0,
      })),
    ],
  },
  {
    id: "44",
    dateTime: "26/02/2026 17:23:38",
    date: "2026-02-26",
    type: "Deposit Cash",
    typeValue: "deposit",
    amount: "1,100",
    createdBy: "QC cash vault manager",
    branch: "Nguyen's store",
    reason: "Regular deposit",
    totalCash: "2,000",
    totalToPay: "1,100",
    denominations: [
      {
        ...DENOMINATIONS.find((d) => d.id === "bill100"),
        id: "bill1000",
        label: "1000 Dollars",
        value: 1000,
        inventory: 2,
        qty: 1,
        image: bill1000,
      },
      ...DENOMINATIONS.map((d) => ({
        ...d,
        inventory: "-",
        qty: d.id === "bill100" ? 1 : 0,
      })),
    ],
  },
];
